import { useTranslation } from "react-i18next";

interface DetailsMetaProps {
	createdAt?: Date | string | null;
	updatedAt?: Date | string | null;
}

/** `dd.mm.yyyy` — the API sends ISO strings even though the schema types them as Date. */
const formatDay = (value?: Date | string | null) => {
	if (!value) {
		return null;
	}

	const parsed = new Date(value);

	if (isNaN(parsed.getTime())) {
		return null;
	}

	return parsed.toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" });
};

/** Created / updated, at the foot of the metadata rail. */
export default function DetailsMeta({ createdAt, updatedAt }: DetailsMetaProps) {
	const { t } = useTranslation();
	const ts = (key: string) => t(`to-do.${key}`);

	const created = formatDay(createdAt);
	const updated = formatDay(updatedAt);

	if (!created && !updated) {
		return null;
	}

	return (
		<dl className="w-full flex flex-col gap-2 border-t border-border pt-4">
			{created ? (
				<div className="flex items-center justify-between gap-2">
					<dt className="text-[12px] font-bold uppercase tracking-wide leading-4 text-subtle">
						{ts("created")}
					</dt>
					<dd className="text-[13px] leading-5 text-primary-blue-dark">{created}</dd>
				</div>
			) : null}
			{updated ? (
				<div className="flex items-center justify-between gap-2">
					<dt className="text-[12px] font-bold uppercase tracking-wide leading-4 text-subtle">
						{ts("updated")}
					</dt>
					<dd className="text-[13px] leading-5 text-primary-blue-dark">{updated}</dd>
				</div>
			) : null}
		</dl>
	);
}
